// Gsap scroller for homepage

jQuery(document).ready(function ($) {

  gsap.registerPlugin(ScrollTrigger);
  const scrollContainer = document.getElementsByClassName('home-articles-container')[0];

  let scroller = {x: 0};

  window.scrollContainer = scrollContainer;

  // gsap.to(scroller, {
  //   x: scrollContainer.scrollWidth,
  //   ease: 'none',
  //   onUpdate: () => {
  //     scrollContainer.scrollLeft = scroller.x;
  //   },
  //   scrollTrigger: {
  //     trigger: '.whatsnew',
  //     start: 'top top',
  //     scrub: true,
  //     pin: true,
  //     invalidateOnRefresh: true,
  //     anticipatePin: 1
  //   },
  // });

})